import { Input as BaseInput, Error, ErrorConnector, HelpText, Label, RequiredStar } from "../common";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { SharedInputProps } from "../Input";
export type DropdownProps = React.SelectHTMLAttributes<HTMLSelectElement> & SharedInputProps & {
  hidePlaceholder?: boolean;
};
const Input = styled(BaseInput).attrs({
  as: "select"
})<{
  rtl?: boolean;
}>`
  // Replace native arrow with custom one
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml; utf8, <svg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'><g id='Icon/claret'><path id='Vector' d='M0.807433 0H11.1926C11.911 0 12.2702 0.867782 11.7617 1.37634L6.57112 6.57093C6.2563 6.88575 5.7437 6.88575 5.42888 6.57093L0.23833 1.37634C-0.270231 0.867782 0.0889903 0 0.807433 0Z' fill='%231a1a1a'/></g></svg>");
  background-color: ${({
  theme
}) => theme.colours.white};
  background-repeat: no-repeat;
  // Offsets from right not supported in Chrome, so have to use large percentage offset from left.
  background-position-x: ${({
  rtl
}) => rtl ? "4%" : "96%"};
  background-position-y: center;
`;
export function Dropdown({
  error,
  helpText,
  label,
  options,
  ...props
}: DropdownProps) {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    id,
    required,
    selectedOption
  } = props;
  const hasError = !!error;
  const selectedOptionId = options?.find(option => option.value === selectedOption)?.optionId;
  return <>
      <Label htmlFor={id} data-sentry-element="Label" data-sentry-source-file="Dropdown.tsx">
        {label}
        {label && required ? <RequiredStar /> : null}
      </Label>
      <HelpText data-sentry-element="HelpText" data-sentry-source-file="Dropdown.tsx">{helpText}</HelpText>
      <Container data-sentry-element="Container" data-sentry-source-file="Dropdown.tsx">
        <ErrorConnector show={hasError} data-sentry-element="ErrorConnector" data-sentry-source-file="Dropdown.tsx">
          <Input error={hasError} defaultValue={selectedOptionId ?? selectedOption ?? "placeholder"} aria-required={required} rtl={i18n.dir() === "rtl"} {...props} data-sentry-element="Input" data-sentry-source-file="Dropdown.tsx">
            {!props.hidePlaceholder && <option value={"placeholder"} disabled={required}>
                {t("dropdownPlaceholder")}
              </option>}
            {options?.map(({
            optionId,
            value
          }) => <option key={optionId} value={optionId}>
                {value}
              </option>)}
          </Input>
          {error ? <Error role="alert">{error}</Error> : null}
        </ErrorConnector>
      </Container>
    </>;
}
const Container = styled.div`
  width: 100%;
`;
export default Dropdown;